import { formatPrice } from 'services/plans'
import { List, Map } from 'immutable'

/**
 * @typedef {Object} PlanDetails
 * @property {Boolean} PlanDetails.loaded
 * @property {Object} PlanDetails.details
 * @property {import('immutable').List<String>} PlanDetails.details.valuePropositions
 * @property {?Sring} PlanDetails.details.planName
 * @property {String} PlanDetails.details.price
 *
 * @param {import('immutable').Map} plan
 * @return {PlanDetails}
 */
export function getPlanDetails (plan, userLangauge) {
  const loaded = Map.isMap(plan)
    && plan.size > 0
  if (loaded) {
    const cost = plan.get('costs').last()
    const currencyIso = plan.get('currencyIso')

    return {
      loaded,
      details: {
        valuePropositions: plan.get('valueProps', List()),
        planName: plan.get('heading') || null,
        price: formatPrice(currencyIso, cost, false, null, userLangauge),
      },
    }
  }
  return {
    loaded,
    details: {
      valuePropositions: List(),
      planName: null,
      price: '',
    },
  }
}

export default getPlanDetails
